import * as Yup from "yup";

export default Yup.object().shape({
    emailAddress: Yup.string()
    .email('Please enter a valid email')
    .required("Email address is required"),
    password: Yup.string().required("Please enter your password")
    .min(3, "Minimum 3 symbols")
    .max(50, "Maximum 50 symbols"),
});